import Cookies from 'universal-cookie';

export const getCookie = (cookieName: string) => {
	const cookies = new Cookies();
	return cookies.get(cookieName) || null;
};
